var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9548 1.01121C23.9101 1.76409 22.7534 2.33993 21.5293 2.71654C20.8723 1.9447 19.9991 1.39763 19.0279 1.14934C18.0566 0.901042 17.0342 0.963498 16.0988 1.32826C15.1634 1.69302 14.3603 2.34249 13.7979 3.18882C13.2356 4.03515 12.9413 5.03751 12.9547 6.06034V7.17494C11.0375 7.22573 9.13786 6.79131 7.42483 5.91037C5.7118 5.02942 4.2386 3.72931 3.13642 2.12581C3.13642 2.12581 -1.22725 12.1572 8.59101 16.6156C6.3443 18.1738 3.66787 18.9551 0.95459 18.8448C10.7728 24.4178 22.7729 18.8448 22.7729 6.0269C22.7719 5.71643 22.7427 5.40673 22.6857 5.10178C23.7991 3.97993 24.5848 2.56352 24.9548 1.01121V1.01121Z",
    stroke: "var(--klothed-textColor)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.eba1fd651be43f271e4ac8df187b252d.svg";
export { ForwardRef as ReactComponent };